module.exports = __webpack_public_path__ + "static/csc-6-858f1aca46a5c765ace6cbfe28c4367f.jpg";